import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  BaseResourceEffects,
  buildLinkageHandlerEffect,
  NoAction,
} from '../base-resource.effects';
import { CoreAppState } from '../core-app.state';
import { filter, map, mergeMap } from 'rxjs';
import {
  HandleOrderCardLinkagesDataPayload,
  HandleOrderLinkagesDataPayload,
  offeredServiceActions,
} from './offered-service.actions';
import { Injectable } from '@angular/core';
import {
  OfferedServiceResourceTypeMappings,
  OrderCardServiceLinkageResourceTypeMappings,
  OrderServiceLinkageResourceTypeMappings,
} from '@aa/nest/resource';
import { OfferedServiceService } from '../../services/offered-service.service';
import { orderActions } from '../order/order.actions';
import { orderCardActions } from '../order-card/order-card.actions';
import { OrderCardServiceLinkageService } from '../../services/order-card-service-linkage.service';
import { OrderServiceLinkageService } from '../../services/order-service-linkage.service';
import { selectOfferedServiceState } from './offered-service.reducer';
import { Store } from '@ngrx/store';

// @aa:gen-ignore

@Injectable()
export class OfferedServiceEffects extends BaseResourceEffects<OfferedServiceResourceTypeMappings> {
  handleOrderLinkages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(offeredServiceActions.handleOrderLinkages),
      filter((payload) => !!payload.data.orderId),
      mergeMap((payload) =>
        buildLinkageHandlerEffect<
          OfferedServiceResourceTypeMappings,
          OrderServiceLinkageResourceTypeMappings,
          OfferedServiceService,
          OrderServiceLinkageService,
          HandleOrderLinkagesDataPayload
        >(
          'offeredServiceId',
          'orderId',
          this.service,
          this.orderServiceLinkageService,
          payload.data,
          ['isDraft'],
          [],
          undefined,
          payload.forDraft ? { isDraft: true } : undefined,
        ).pipe(
          map(() =>
            payload.noRefresh ? NoAction() : orderActions.refreshItem(),
          ),
        ),
      ),
    ),
  );

  handleOrderCardLinkages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(offeredServiceActions.handleOrderCardLinkages),
      filter((payload) => !!payload.data.orderCardId),
      mergeMap((payload) =>
        buildLinkageHandlerEffect<
          OfferedServiceResourceTypeMappings,
          OrderCardServiceLinkageResourceTypeMappings,
          OfferedServiceService,
          OrderCardServiceLinkageService,
          HandleOrderCardLinkagesDataPayload
        >(
          'offeredServiceId',
          'orderCardId',
          this.service,
          this.orderCardServiceLinkageService,
          payload.data,
          ['isDraft', 'customPrice'],
          [],
          undefined,
          payload.forDraft ? { isDraft: true } : undefined,
        ).pipe(
          map(() =>
            payload.chainedAction
              ? payload.chainedAction
              : orderCardActions.reloadItems(),
          ),
        ),
      ),
    ),
  );

  constructor(
    protected override readonly actions$: Actions,
    protected override readonly store: Store<CoreAppState>,
    protected override readonly service: OfferedServiceService,
    private readonly orderServiceLinkageService: OrderServiceLinkageService,
    private readonly orderCardServiceLinkageService: OrderCardServiceLinkageService,
  ) {
    super(
      actions$,
      store,
      service,
      offeredServiceActions,
      selectOfferedServiceState,
    );
  }
}
